export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-[32px] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20terracotta%20and%20sage%20green%20gradient%20with%20textured%20organic%20waves%20and%20soft%20geometric%20shapes%2C%20modern%20artistic%20composition%2C%20clean%20minimalist%20design%2C%20natural%20earthy%20color%20palette%2C%20subtle%20grain%20texture&width=1200&height=500&seq=cta-bg-v2&orientation=landscape"
              alt="Pandabuy Spreadsheet collection"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-foreground-950/55"></div>
          </div>

          <div className="relative z-10 py-16 md:py-20 px-6 md:px-12 text-center">
            <h2 className="font-heading text-3xl md:text-5xl text-background-50 leading-[1.15] mb-4 max-w-2xl mx-auto">
              Ready to Discover the <span className="italic">Best Pandabuy Spreadsheet</span> Finds?
            </h2>
            <p className="text-sm md:text-base text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
              Join thousands of savvy shoppers who use our curated pandabuy sheet to find trending fashion, sneakers, and accessories every day.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-950 rounded-full text-base font-semibold hover:bg-background-100 transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
              >
                View Pandabuy Sheet
                <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-shopping-bag-line text-lg group-hover:translate-x-0.5 transition-transform"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}